// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://uawdnefgdkptlscgqiho.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVhd2RuZWZnZGtwdGxzY2dxaWhvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzUxMjQyMDIsImV4cCI6MjA1MDcwMDIwMn0.Lh6RPB-0pYje1ZLdD7knvlSW5NXO2BXoo5iR4VPYXok";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);